function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { fg } from '@atlaskit/platform-feature-flags';
var CITATION_REGEX = /\[\^(\d+)\^\]/;

/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */
var citation = function citation(state) {
  var tokens = [];

  // TODO: Remove the next two lines when rovo_chat_simplify_citation_logic enabled and cleaned up
  var citationIndexMap = {};
  var currentIndex = 1;
  var _iterator = _createForOfIteratorHelper(state.tokens),
    _step;
  try {
    var _loop = function _loop() {
      var _token$children;
      var token = _step.value;
      var tokenChildren = [];
      if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
        tokens.push(token);
        return 1; // continue
      }
      if (token.children) {
        token.children.forEach(function (childToken) {
          if (childToken.type === 'text' && CITATION_REGEX.test(childToken.content)) {
            /**
             * Example content: `Hello [^1^][^1^].`
             * `parts` will be ['Hello ', '1', '', '1', '.']
             */
            var parts = childToken.content.split(CITATION_REGEX);
            var newChildren = [];

            /**
             * we want to remove consecutive citation
             * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
             * should be transformed to `Hello 1. How are you 1 2`
             */
            var lastCitation = null;
            var isLastCitationDuplicate = false;

            // only want to add space in the next part after citation
            // if the last citation is valid

            parts.forEach(function (part, index) {
              if (index % 2 === 0) {
                // this is a text part

                /**
                 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
                 * So it doesn't end up rendering empty space that will end up with multi empty spaces
                 * because previous valid citation already added 1 empty space
                 *
                 * Example: For `[^1^][^1^]`
                 * it will be split into parts: ['', '1', '', '1', ''],
                 * This code will skip any rendering for the last empty string (index=4)
                 * Because the empty string at index=2 already added 1 empty space from the code below
                 */
                if (isLastCitationDuplicate && part.trim() === '') {
                  return;
                }
                if (part.trim() !== '') {
                  /**
                   * if the text part is not an empty string, we want to reset the last citation
                   * because the text part is a valid text, and not a space between citations
                   * so that we can render citation again, even if the next number is the same as the last number
                   *
                   * Example:
                   * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                   */
                  lastCitation = null;
                }
                var textToken = new state.Token('text', '', 0);
                if (index === parts.length - 1) {
                  textToken.content = part;
                } else {
                  textToken.content = part + ' ';
                }
                textToken.block = false;
                textToken.level = childToken.level;
                newChildren.push(textToken);
              } else {
                // this is a citation part

                // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                if (part === lastCitation) {
                  isLastCitationDuplicate = true;
                  return;
                } else {
                  // always reset the duplicate flag
                  isLastCitationDuplicate = false;
                  lastCitation = part;
                }
                var citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                var citationText = part;
                if (!fg('rovo_chat_simplify_citation_logic')) {
                  citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                  if (!citationIndexMap[part]) {
                    citationIndexMap[part] = currentIndex;
                    currentIndex++;
                  }
                }
                citationToken.attrs = [['color', 'blue'], ['text', citationText],
                // localId is used to identify the citation token in the DOM
                // this overrides the uuid that is normally used
                ['localId', "citation-".concat(citationText)]];
                citationToken.content = citationText;
                newChildren.push(citationToken);
              }
            });
            tokenChildren.push.apply(tokenChildren, newChildren);
            return;
          }
          tokenChildren.push(childToken);
        });
      }
      var filteredTokenChildren = tokenChildren.filter(function (childToken) {
        return childToken !== null;
      });
      token.children = filteredTokenChildren;
      tokens.push(token);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  state.tokens = tokens;
  return;
};
export default (function (md) {
  return md.core.ruler.push('citation', citation);
});